export const SORT_ICON_SELECTOR = 'jira-native-issue-table-sort-icon';
export const HEADER_CELL_CONTENT_SELECTOR = 'jira-native-issue-table-header-cell-content';
